import { getViewMode } from '../../app/selectors/search-params-selectors';
import createAction from '../../app/services/create-action';

export const CONTENT_MIGRATION_ROLLBACK_REQUEST = 'contentMigration/ROLLBACK_REQUEST';
export const CONTENT_MIGRATION_ROLLBACK_SUCCESS = 'contentMigration/ROLLBACK_SUCCESS';
export const CONTENT_MIGRATION_ROLLBACK_FAILURE = 'contentMigration/ROLLBACK_FAILURE';

export const contentMigrationRollbackRequest = createAction(CONTENT_MIGRATION_ROLLBACK_REQUEST);
export const contentMigrationRollbackSuccess = createAction(CONTENT_MIGRATION_ROLLBACK_SUCCESS);
export const contentMigrationRollbackFailure = createAction(CONTENT_MIGRATION_ROLLBACK_FAILURE);

const MIGRATION_ROLLBACK_PATH = '/_api/content-migration/rollback';
export const getMigrationRollbackPath = viewMode => `${MIGRATION_ROLLBACK_PATH}?viewMode=${viewMode}`;

export const contentMigrationRollback = () => (dispatch, getState, { request }) => {
  dispatch(contentMigrationRollbackRequest());

  const viewMode = getViewMode(getState());
  const promise = request.post(getMigrationRollbackPath(viewMode));
  return promise
    .then(
      details => dispatch(contentMigrationRollbackSuccess(details)),
      () => dispatch(contentMigrationRollbackFailure()),
    )
    .then(() => promise);
};
